import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#050505] text-gray-300 p-8 font-sans selection:bg-blue-500/30">
            <div className="max-w-4xl mx-auto">
                <Button
                    variant="ghost"
                    onClick={() => navigate('/')}
                    className="mb-8 hover:bg-white/5 text-gray-400 hover:text-white"
                >
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Voltar para o Login
                </Button>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden"
                >
                    {/* Header */}
                    <div className="flex items-center gap-4 mb-10 border-b border-white/5 pb-8">
                        <div className="p-3 bg-blue-500/10 rounded-xl">
                            <Lock className="h-8 w-8 text-blue-500" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-white mb-1">Política de Privacidade</h1>
                            <p className="text-gray-500">Última atualização: {new Date().toLocaleDateString()}</p>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="space-y-8 text-lg leading-relaxed">
                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">1. Coleta de Informações</h2>
                            <p>
                                Coletamos informações limitadas necessárias para o funcionamento do serviço, incluindo:
                            </p>
                            <ul className="list-disc pl-6 space-y-2 mt-2 text-gray-400">
                                <li>ID do usuário, nome de usuário e avatar do Discord.</li>
                                <li>Endereço IP para fins de segurança e prevenção de fraudes.</li>
                                <li>Registros de atividades dentro do sistema (tickets, comentários, ações).</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">2. Uso das Informações</h2>
                            <p>
                                Utilizamos suas informações para:
                            </p>
                            <ul className="list-disc pl-6 space-y-2 mt-2 text-gray-400">
                                <li>Fornecer, manter e melhorar nossos serviços.</li>
                                <li>Autenticar sua identidade via Discord.</li>
                                <li>Processar suas solicitações e tickets de suporte.</li>
                                <li>Detectar e prevenir fraudes e abusos.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">3. Compartilhamento de Dados</h2>
                            <p>
                                Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto quando
                                exigido por lei ou para proteger nossos direitos.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">4. Cookies e Armazenamento Local</h2>
                            <p>
                                Utilizamos armazenamento local do navegador (LocalStorage) e cookies essenciais para manter sua
                                sessão ativa e salvar suas preferências de usuário.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">5. Segurança dos Dados</h2>
                            <p>
                                Implementamos medidas de segurança técnicas e organizacionais para proteger seus dados contra
                                acesso não autorizado, perda ou alteração.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">6. Seus Direitos</h2>
                            <p>
                                Você tem o direito de solicitar o acesso, correção ou exclusão de seus dados pessoais armazenados
                                em nosso sistema. Entre em contato com a administração para exercer esses direitos.
                            </p>
                        </section>
                    </div>

                    <div className="mt-12 pt-8 border-t border-white/5 text-center text-sm text-gray-500">
                        &copy; {new Date().getFullYear()} Grupo Capital. Todos os direitos reservados.
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
